import axios from 'axios';
import 'utils/axios_configuration';
import * as APIRoutes from 'constants/APIRoutes';
import { helper, axius } from 'utils';
// import
// TODO: axios default configurations
class AuthAPI {
	static async postLoginDetails(postData) {
		try {
			// fetch data from a url endpoint
			const response = await axios.post(APIRoutes.CLIENT_LOGIN, postData);
			return response.data;
		} catch (error) {
			throw error.response.data;
		}
	}

	static async getUserData() {
		const logg = helper.getStorageJson('userData') || {};
		const roles = helper.getStorageJson('roles') || [];
		// fetch data from a url endpoint
		if (logg.id) {
			let res = await axius.get(`users/me`);
			if (res.status === 200) {
				const data = { ...res.data };
				// data.roleId = types.UserRoles.OPERATIONS;
				data.role = roles.find((r) => r.id === data.roleId);
				data.stores = data.stores.sort((a, b) => a.name.localeCompare(b.name));
				helper.setStorageJson('user', data);
				helper.setStorageJson('userData', data);
				return helper.mapUser(data);
			} else {
				if (logg.id && res.status === 401) {
					localStorage.clear();
					sessionStorage.clear();
					helper.setStorage('expired', 'yah');
					window.location.replace('/');
				}
			}
		}
		return;
	}

	static async updateUser(data) {
		const logg = helper.getStorageJson('userData');
		const res = await axius.put(`users/${logg.id}`, data);
		return res.data;
	}

	static async verifyCredentails(postData) {
		const data = { email: postData };
		try {
			// fetch data from a url endpoint
			const response = await axios.post(APIRoutes.VERIFY_CREDENTIALS, data);
			return response.data;
		} catch (error) {
			throw error.response.data;
		}
	}

	static async checkCode(postData) {
		try {
			// fetch data from a url endpoint
			const response = await axios.post(APIRoutes.CHECK_EMAIL_CODE, postData);
			return response.data;
		} catch (error) {
			throw error.response.data;
		}
	}

	static async getEmailOtp(postData) {
		try {
			// fetch data from a url endpoint
			const response = await axios.post(APIRoutes.GET_EMAIL_OTP, postData);
			return response.data;
		} catch (error) {
			throw error.response.data;
		}
	}

	static async collaboratorSignup(data) {
		try {
			let URL;
			if (data.outlet_event) {
				URL = APIRoutes.INVITE_COLLABORATOR_EVENT(data.outlet_event);
			} else if (data.outlet_venue) {
				URL = APIRoutes.INVITE_COLLABORATOR_VENUE(data.outlet_venue);
			}
			const response = await axios.post(URL, data);
			return response.data;
		} catch (error) {
			throw error.response.data;
		}
	}

	static async getUsers() {
		try {
			// fetch data from a url endpoint
			const response = await axios.get(APIRoutes.GET_ALL_USERS);
			return response.data;
		} catch (error) {
			throw error.response.data;
		}
	}

	static async getUserLimits(data) {
		try {
			// fetch data from a url endpoint
			const response = await axios.post(APIRoutes.GET_USER_LIMIT, data);
			return response.data;
		} catch (error) {
			throw error.response.data;
		}
	}
}
export default AuthAPI;
